let mesAtual = new Date().getMonth() + 1;
mesAtual = mesAtual < 10 ? "0" + mesAtual : mesAtual;

const INITIAL_STATE = {
    registro: {},
    modoTela: "lista",
    aguardando: false,
    contratoDemanda: null,
    listaDemandas: [],
    listaTarifaTeTusdMensal: Array.from({ length: 12 }, () => ({ media_te: 0, media_tusd: 0 })),
    listaDemandaContagem: [],
    listaGraficoCustoAnual: [],
    listaGraficoCustoJurosPorAtrasoPagamentoAnual: [],
    listaGraficoCustoJurosPorAtrasoPagamentoMensal: [],
    listaGraficoConsumoAnual: [],
    listaGraficoTarifaMedia: [],
    listaGraficoTarifaMediaGeral: [],
    listaGraficoGeracaoQuantidadeAnual: [],
    listaGraficoCustoUnidadeAnual: [],
    listaCustoPorUnidadePeriodo: [],
    listaConsumoPorUnidadePeriodo: [],
    listaGraficoCustoUnidadeMensal: [],
    listaGraficoCustoPorUnidadeAcumuladoAno: [],
    listaGraficoConsumoPorUnidadeAcumuladoAno: [],
    listaGraficoCustoHorarioAnual: [],
    listaGraficoConsumoHorarioAnual: [],
    listaGraficoConsumoHorarioMensal: [],
    listaGraficoConsumoPonta: [],
    listaGraficoConsumoForaPonta: [],
    listaGraficoConsumoReservado: [],
    listaGraficoCustoDemandaEnergiaConsumida: [],
    listaGraficoDemanda: [],
    listaGraficoDemandaIndicesSazonalidade: [],
    listaGraficoCustoReativoAnual: [],
    listaGraficoCustoReativoMensal: [],
    listaGraficoConsumoReativoMensal: [],
    listaGeracaoContrato: [],
    listaGraficoGeracaoSaldo: [],
    listaGraficoGeracaoAvaliacaoProducaoAnual: [],
    listaGraficoGeracaoAvaliacaoProducaoMensal: [],
    listaGraficoGeracaoComparativoConsumo: [],
    listaGraficoGeracaoEconomia: [],
    listaGraficoGeracaoEconomiaPonta: [],
    listaGraficoGeracaoConsumoInstantaneo: [],
    listaGraficoCustoReativoPorUnidadeAcumuladoAno: [],
    listaGraficoCustoReativoUnidadeAnual: [],
    listaCliente: [],
    listaUnidadeConsumidora: [],
    listaDemandaContratoTipo: [],
    listaGraficoCustoTiposMulta: [],
    listaGraficoCustoMulta: [],
    listaGraficoCustoMultaAgrupado: [],
    listarGraficoCustoReativoTipo: [],
    listarGraficoCustoReativoTipoMulta: [],
    listaGraficoCustoMultaPorUnidade: [],
    listaEmpenho: [],
    listaGraficoCustoMercadoLivreMensal: Array.from({ length: 12 }, () => ({})),
    listaGraficoCustoMercadoLivrePeriodo: [],
    listaGraficoCustoMercadoLivreTipo: [],
    listaAnosEmpenho: [],
    listaGraficoValorDevolvidoAnual: [],
    listaGraficoValorDevolvidoMensalAno: [],
    listaGraficoValorDevolvidoRessarcidoPeriodo: [],
    listaGraficoValorDevolvidoPorUC: [],
    listaConsumoPercentualPorHorarioComparativoPeriodo: [],
    listaAgendamentoDemanda: [],
    listaTarifasAneelPeriodo: [],
    listaTarifasAneelMensal: [],
    listaIndiceAntesDepois: [],
    listaGraficoAluguelUsinaMensal: [],
    listaEconomiaUsinaAluguelRemotasMensal: [],
    listaContratoAluguelHistorico: [],
    listaGeradorasContratoAluguelHistorico: [],
    listaCustoReativoPorUnidadePeriodo: [],
    listaGraficoComparativoComSemSolarMensal: [],
    listaGraficoComparativoComSemSolarPeriodo: [],

    filtro: {
        ano_referencia: `${new Date().getFullYear()}`, //usado na analise de empenho e mercado livre

        //mercado livre--------------------------------------------------------------------------------------------------------------
        ano_mercado_livre: `${new Date().getFullYear()}`,
        competencia_inicial_mercado_livre: `${new Date().getFullYear()}01`,
        competencia_final_mercado_livre: `${new Date().getFullYear()}${mesAtual}`,

        //tarifa--------------------------------------------------------------------------------------------------------------
        ano_tarifa: `${new Date().getFullYear()}`,
        tarifa_ano_safra: false,
        horario_tarifa: "0",

        //custo--------------------------------------------------------------------------------------------------------------
        ano_custo: `${new Date().getFullYear()}`,
        custo_ano_safra: false,
        tipo_periodo: "Padrão",
        competencia_inicial_custo: `${new Date().getFullYear()}01`,
        competencia_final_custo: `${new Date().getFullYear()}${mesAtual}`,
        competencia_inicial_unidade_custo: `${new Date().getFullYear()}01`,
        competencia_final_unidade_custo: `${new Date().getFullYear()}${mesAtual}`,
        competencia_inicial_custo_comparativo_antes: `${new Date().getFullYear() - 1}01`,
        competencia_final_custo_comparativo_antes: `${new Date().getFullYear() - 1}${mesAtual}`,
        competencia_inicial_custo_comparativo_depois: `${new Date().getFullYear()}01`,
        competencia_final_custo_comparativo_depois: `${new Date().getFullYear()}${mesAtual}`,
        ano_acumulado_custo: new Date().getFullYear(),
        //consumo--------------------------------------------------------------------------------------------------------------
        ano_consumo: `${new Date().getFullYear()}`,
        consumo_ano_safra: false,
        competencia_inicial_consumo_comparativo_antes: `${new Date().getFullYear() - 1}01`,
        competencia_final_consumo_comparativo_antes: `${new Date().getFullYear() - 1}${mesAtual}`,
        competencia_inicial_consumo_comparativo_depois: `${new Date().getFullYear()}01`,
        competencia_final_consumo_comparativo_depois: `${new Date().getFullYear()}${mesAtual}`,
        ano_acumulado_consumo: new Date().getFullYear(),
        //devolucao--------------------------------------------------------------------------------------------------------------
        ano_devolucao: `${new Date().getFullYear()}`, //usado no grafico mensal da aba devoluções
        devolucao_ano_safra: false,
        competencia_inicial_comparativo_devolucao_ressarcimento: `${new Date().getFullYear()}01`, //usado no grafico pizza da aba devoluções
        competencia_final_comparativo_devolucao_ressarcimento: `${new Date().getFullYear()}${mesAtual}`, //usado no grafico pizza da aba devoluções
        competencia_inicial_devolucao_por_uc: `${new Date().getFullYear()}01`, //usado no grafico barras da aba devoluções
        competencia_final_devolucao_por_uc: `${new Date().getFullYear()}${mesAtual}`, //usado no grafico barras da aba devoluções
        //multas--------------------------------------------------------------------------------------------------------------
        ano_multas: `${new Date().getFullYear()}`,
        multas_ano_safra: false,
        competencia_inicial_comparativo_tipo_multa: `${new Date().getFullYear()}01`,
        competencia_final_comparativo_tipo_multa: `${new Date().getFullYear()}${mesAtual}`,
        //reativo--------------------------------------------------------------------------------------------------------------
        ano_reativo: `${new Date().getFullYear()}`,
        reativo_ano_safra: false,
        competencia_inicial_reativo: `${new Date().getFullYear()}01`,
        competencia_final_reativo: `${new Date().getFullYear()}${mesAtual}`,
        competencia_inicial_custo_reativo_comparativo_antes: `${new Date().getFullYear() - 1}01`,
        competencia_final_custo_reativo_comparativo_antes: `${new Date().getFullYear() - 1}${mesAtual}`,
        competencia_inicial_custo_reativo_comparativo_depois: `${new Date().getFullYear()}01`,
        competencia_final_custo_reativo_comparativo_depois: `${new Date().getFullYear()}${mesAtual}`,
        //horario--------------------------------------------------------------------------------------------------------------
        ano: null, //pizza
        ano_horario: `${new Date().getFullYear()}`,
        horario_ano_safra: false,
        competencia_inicial_horario: `${new Date().getFullYear()}01`,
        competencia_final_horario: `${new Date().getFullYear()}${mesAtual}`,
        competencia_inicial_horario_comparativo_antes: `${new Date().getFullYear() - 1}01`,
        competencia_final_horario_comparativo_antes: `${new Date().getFullYear() - 1}${mesAtual}`,
        competencia_inicial_horario_comparativo_depois: `${new Date().getFullYear()}01`,
        competencia_final_horario_comparativo_depois: `${new Date().getFullYear()}${mesAtual}`,

        //geração
        ano_comparativo_com_sem_solar: `${new Date().getFullYear()}`,
        competencia_inicial_geracao_comparativo_com_sem_solar: `${new Date().getFullYear()}01`,
        competencia_final_geracao_comparativo_com_sem_solar: `${new Date().getFullYear()}${mesAtual}`,

        //geral ------
        id_cliente: null,
        id_unidade_consumidora: null,
        unidades_consumidoras: [],
        grupos_faturamento: [],
        irrigante: true,
        naoIrrigante: true,

        //demandas ------------------------------------------------------------------------------------------------------------
        id_tipo_contrato_demanda: 1, //padrão traz somente fora ponta

        //contrato de aluguel
        id_unidade_geradora_contrato_aluguel: null,
        id_contrato_aluguel_historico: null,
        ids_contrato_aluguel_historico: [],
        id_unidade_remota_contrato_aluguel: null
    },
    tabSelecionada: "custo",
    listaAbas: ["custo", "consumo", "tarifa", "horario", "demanda", "reativo", "multas", "excedente", "empenho", "devolucao", "mercadoLivre", "contratoAluguel", "INDEFINIDA"],
    // abas: {
    //     custo: false,
    //     consumo: false,
    //     tarifa: false,
    //     horario: false,
    //     demanda: false,
    //     reativo: false,
    //     multas: false,
    //     excedente: false,
    //     empenho: false,
    //     devolucao: false,
    //     mercadoLivre: false,
    //     contratoAluguel: false,
    // },
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "ANALISE_SET_FILTRO":
            return { ...state, filtro: action.payload };

        case "ANALISE_SET_AGUARDANDO":
            return { ...state, aguardando: action.payload };

        case "ANALISE_TAB_SELECIONADA":
            return { ...state, tabSelecionada: action.payload };

        // case "ANALISE_ABAS_CARREGADA":
        //     return { ...state, abas: action.payload };

        case "ANALISE_DEMANDA_LISTADO":
            return {
                ...state,
                contratoDemanda: action.payload ? action.payload.vigente : null,
                listaDemandas: action.payload ? action.payload.demandas : [],
            };

        case "ANALISE_GRAFICO_TARIFA_TE_TUSD_MENSAL_LISTADO":
            return {
                ...state,
                listaTarifaTeTusdMensal: action.payload.data,
            };
        case "ANALISE_DEMANDA_CONTAGEM_LISTADO":
            return {
                ...state,
                listaDemandaContagem: action.payload.data,
            };

        case "ANALISE_GRAFICO_CUSTO_ANUAL_LISTADO":
            return {
                ...state,
                listaGraficoCustoAnual: action.payload.data,
            };

        case "ANALISE_GRAFICO_CONSUMO_ANUAL_LISTADO":
            return {
                ...state,
                listaGraficoConsumoAnual: action.payload.data,
            };

        case "ANALISE_GRAFICO_TARIFA_MEDIA_LISTADO":
            return {
                ...state,
                listaGraficoTarifaMedia: action.payload.data,
            };

        case "ANALISE_GRAFICO_TARIFA_MEDIA_GERAL_LISTADO":
            return {
                ...state,
                listaGraficoTarifaMediaGeral: action.payload.data,
            };

        case "ANALISE_GRAFICO_CUSTO_UNIDADE_ACUMULADO_ANO_LISTADO":
            return {
                ...state,
                listaGraficoCustoPorUnidadeAcumuladoAno: action.payload.data,
            };

        case "ANALISE_GRAFICO_CONSUMO_UNIDADE_ACUMULADO_ANO_LISTADO":
            return {
                ...state,
                listaGraficoConsumoPorUnidadeAcumuladoAno: action.payload.data,
            };
        case "ANALISE_GRAFICO_GERACAO_QUANTIDADE_ANUAL_LISTADO":
            return {
                ...state,
                listaGraficoGeracaoQuantidadeAnual: action.payload.data,
            };

        case "ANALISE_GRAFICO_CUSTO_UNIDADE_ANUAL_LISTADO":
            return {
                ...state,
                listaGraficoCustoUnidadeAnual: action.payload.data,
            };
        case "ANALISE_GRAFICO_CUSTO_JUROS_POR_ATRASO_PAGAMENTO_ANUAL_LISTADO":
            return {
                ...state,
                listaGraficoCustoJurosPorAtrasoPagamentoAnual: action.payload.data,
            };
        case "ANALISE_GRAFICO_CUSTO_JUROS_POR_ATRASO_PAGAMENTO_MENSAL_LISTADO":
            return {
                ...state,
                listaGraficoCustoJurosPorAtrasoPagamentoMensal: action.payload.data,
            };

        case "ANALISE_CUSTO_POR_UNIDADE_PERIODO_LISTADO":
            return {
                ...state,
                listaCustoPorUnidadePeriodo: action.payload.data,
            };

        case "ANALISE_CONSUMO_POR_UNIDADE_PERIODO_LISTADO":
            return {
                ...state,
                listaConsumoPorUnidadePeriodo: action.payload.data,
            };

        case "ANALISE_GRAFICO_CUSTO_UNIDADE_MENSAL_LISTADO":
            return {
                ...state,
                listaGraficoCustoUnidadeMensal: action.payload.data,
            };

        case "ANALISE_GRAFICO_CUSTO_HORARIO_ANUAL_LISTADO":
            return {
                ...state,
                listaGraficoCustoHorarioAnual: action.payload.data,
            };

        case "ANALISE_GRAFICO_CONSUMO_HORARIO_ANUAL_LISTADO":
            return {
                ...state,
                listaGraficoConsumoHorarioAnual: action.payload.data,
            };

        case "ANALISE_TABELA_CONSUMO_HORARIO_COMPARATIVO_PERIODO_LISTADO":
            return {
                ...state,
                listaConsumoPercentualPorHorarioComparativoPeriodo: action.payload.data,
            };

        case "ANALISE_GRAFICO_CONSUMO_HORARIO_MENSAL_LISTADO":
            return {
                ...state,
                listaGraficoConsumoHorarioMensal: action.payload.data,
            };

        case "ANALISE_GRAFICO_CONSUMO_PONTA_LISTADO":
            return {
                ...state,
                listaGraficoConsumoPonta: action.payload.data,
            };

        case "ANALISE_GRAFICO_CONSUMO_FORA_PONTA_LISTADO":
            return {
                ...state,
                listaGraficoConsumoForaPonta: action.payload.data,
            };

        case "ANALISE_GRAFICO_CONSUMO_RESERVADO_LISTADO":
            return {
                ...state,
                listaGraficoConsumoReservado: action.payload.data,
            };

        case "ANALISE_GRAFICO_CUSTO_DEMANDA_ENERGIA_CONSUMIDA_LISTADO":
            return {
                ...state,
                listaGraficoCustoDemandaEnergiaConsumida: action.payload.data,
            };

        case "ANALISE_GRAFICO_DEMANDA_LISTADO":
            return {
                ...state,
                listaGraficoDemanda: action.payload.data,
            };

        case "ANALISE_GRAFICO_DEMANDA_INDICE_SAZONALIDADE_LISTADO":
            return {
                ...state,
                listaGraficoDemandaIndicesSazonalidade: action.payload.data,
            };

        case "ANALISE_GRAFICO_CUSTO_REATIVO_LISTADO_ANUAL":
            return {
                ...state,
                listaGraficoCustoReativoAnual: action.payload.data,
            };
        case "ANALISE_GRAFICO_CUSTO_REATIVO_LISTADO_MENSAL":
            return {
                ...state,
                listaGraficoCustoReativoMensal: action.payload.data,
            };

        case "ANALISE_GRAFICO_CONSUMO_REATIVO_LISTADO_MENSAL":
            return {
                ...state,
                listaGraficoConsumoReativoMensal: action.payload.data,
            };

        case "ANALISE_GRAFICO_GERACAO_CADASTRO_LISTADO":
            return {
                ...state,
                listaGeracaoContrato: action.payload.data,
            };

        case "ANALISE_GRAFICO_GERACAO_SALDO_LISTADO":
            return {
                ...state,
                listaGraficoGeracaoSaldo: action.payload.data,
            };

        case "ANALISE_GERACAO_INDICE_ANTES_DEPOIS_LISTADO":
            return {
                ...state,
                listaIndiceAntesDepois: action.payload.data,
            };

        case "ANALISE_GRAFICO_GERACAO_AVALIACAO_PRODUCAO_LISTADO":
            return {
                ...state,
                listaGraficoGeracaoAvaliacaoProducaoAnual: action.payload.data,
            };

        case "ANALISE_GRAFICO_GERACAO_COMPARATIVO_CONSUMO_LISTADO":
            return {
                ...state,
                listaGraficoGeracaoComparativoConsumo: action.payload.data,
            };

        case "ANALISE_GRAFICO_GERACAO_ECONOMIA_LISTADO":
            return {
                ...state,
                listaGraficoGeracaoEconomia: action.payload.data,
            };

        case "ANALISE_GRAFICO_GERACAO_CONSUMO_INSTANTANEO_LISTADO":
            return {
                ...state,
                listaGraficoGeracaoConsumoInstantaneo: action.payload.data,
            };

        case "ANALISE_GRAFICO_GERACAO_ECONOMIA_PONTA_LISTADO":
            return {
                ...state,
                listaGraficoGeracaoEconomiaPonta: action.payload.data,
            };

        case "ANALISE_CLIENTE_SELECT_LISTADO":
            return {
                ...state,
                listaCliente: action.payload.data,
            };

        case "ANALISE_CONTRATO_ALUGUEL_HISTORICO_SELECT_LISTADO":
            return {
                ...state,
                listaContratoAluguelHistorico: action.payload.data,
            };

        case "ANALISE_GERADORAS_CONTRATO_ALUGUEL_HISTORICO_SELECT_LISTADO":
            return {
                ...state,
                listaGeradorasContratoAluguelHistorico: action.payload.data,
            };

        case "ANALISE_CONTRATO_DEMANDA_TIPO_SELECT_LISTADO":
            return {
                ...state,
                listaDemandaContratoTipo: action.payload.data,
            };

        case "ANALISE_UNIDADE_CONSUMIDORA_SELECT_LISTADO":
            return {
                ...state,
                listaUnidadeConsumidora: action.payload.data,
            };

        case "ANALISE_GRAFICO_CUSTO_REATIVO_UNIDADE_ACUMULADO_ANO_LISTADO":
            return {
                ...state,
                listaGraficoCustoReativoPorUnidadeAcumuladoAno: action.payload.data,
            };

        case "ANALISE_GRAFICO_CUSTO_REATIVO_UNIDADE_ANUAL_LISTADO":
            return {
                ...state,
                listaGraficoCustoReativoUnidadeAnual: action.payload.data,
            };

        case "ANALISE_GRAFICO_CUSTO_TIPO_MULTA_ANUAL_LISTADO":
            return {
                ...state,
                listaGraficoCustoTiposMulta: action.payload.data,
            };

        case "ANALISE_GRAFICO_CUSTO_MULTA_ANUAL_LISTADO":
            return {
                ...state,
                listaGraficoCustoMulta: action.payload.data,
            };

        case "ANALISE_GRAFICO_CUSTO_REATIVO_TIPO_LISTADO":
            return {
                ...state,
                listarGraficoCustoReativoTipo: action.payload.data,
            };

        case "ANALISE_GRAFICO_CUSTO_REATIVO_TIPO_MULTA_LISTADO":
            return {
                ...state,
                listarGraficoCustoReativoTipoMulta: action.payload.data,
            };

        case "ANALISE_GRAFICO_CUSTO_MULTA_AGRUPADO_LISTADO":
            return {
                ...state,
                listaGraficoCustoMultaAgrupado: action.payload.data,
            };

        case "ANALISE_GRAFICO_CUSTO_MULTA_UNIDADE_ACUMULADO_ANO_LISTADO":
            return {
                ...state,
                listaGraficoCustoMultaPorUnidade: action.payload.data,
            };
        case "ANALISE_GRAFICO_DEVOLUCAO_ANUAL_LISTADO":
            return {
                ...state,
                listaGraficoValorDevolvidoAnual: action.payload.data,
            };
        case "ANALISE_GRAFICO_DEVOLUCAO_MENSAL_LISTADO":
            return {
                ...state,
                listaGraficoValorDevolvidoMensalAno: action.payload.data,
            };
        case "ANALISE_GRAFICO_DEVOLUCAO_RESSARCIMENTO_LISTADO":
            return {
                ...state,
                listaGraficoValorDevolvidoRessarcidoPeriodo: action.payload.data,
            };
        case "ANALISE_GRAFICO_DEVOLUCAO_POR_UC_LISTADO":
            return {
                ...state,
                listaGraficoValorDevolvidoPorUC: [...action.payload.data].sort((a, b) => a.valor - b.valor),
            };

        case "ANALISE_TABELA_GESTAO_EMPENHO_LISTADO":
            return {
                ...state,
                listaEmpenho: action.payload.data,
            };
        case "ANALISE_GRAFICO_CUSTO_MERCADO_LIVRE_MENSAL":
            return {
                ...state,
                listaGraficoCustoMercadoLivreMensal: action.payload,
            };
        case "ANALISE_GRAFICO_CUSTO_MERCADO_LIVRE_PERIODO":
            return {
                ...state,
                listaGraficoCustoMercadoLivrePeriodo: action.payload,
            };
        case "ANALISE_GRAFICO_CUSTO_MERCADO_LIVRE_TIPO":
            return {
                ...state,
                listaGraficoCustoMercadoLivreTipo: action.payload,
            };
        case "ANALISE_TABELA_GESTAO_EMPENHO_LISTA_ANOS":
            return {
                ...state,
                listaAnosEmpenho: action.payload.data,
                filtro: {
                    ...state.filtro,
                    ano_referencia: state.ano_referencia || (action.payload.data.length && action.payload.data[0].id),
                },
            };
        case "ANALISE_AGENDAMENTO_DEMANDA":
            return {
                ...state,
                listaAgendamentoDemanda: action.payload.data,
            };
        case "ANALISE_TARIFAS_ANEEL_PERIODO":
            return {
                ...state,
                listaTarifasAneelPeriodo: action.payload,
            };
        case "ANALISE_TARIFAS_ANEEL_MENSAL":
            return {
                ...state,
                listaTarifasAneelMensal: action.payload,
            };
        case "ANALISE_GRAFICO_ALUGUEL_USINA_MENSAL_LISTADO":
            return {
                ...state,
                listaGraficoAluguelUsinaMensal: action.payload.data,
            };
        case "ANALISE_ECONOMIA_REMOTAS_USINA_ALUGUEL_MENSAL_LISTADO":
            return {
                ...state,
                listaEconomiaUsinaAluguelRemotasMensal: action.payload.data,
            };
        case "ANALISE_CONSUMO_REATIVO_POR_UNIDADE_PERIODO_LISTADO":
            return {
                ...state,
                listaCustoReativoPorUnidadePeriodo: action.payload.data,
            };
        case "ANALISE_GERACAO_GRAFICO_COMPARATIVO_COM_SEM_SOLAR_MENSAL_LISTADO":
            return {
                ...state,
                listaGraficoComparativoComSemSolarMensal: action.payload.data,
            };
        case "ANALISE_GERACAO_GRAFICO_COMPARATIVO_COM_SEM_SOLAR_PERIODO_LISTADO":
            return {
                ...state,
                listaGraficoComparativoComSemSolarPeriodo: action.payload.data,
            };

        default:
            return state;
    }
};
